// extracted by mini-css-extract-plugin
export default {"top-banner":"TopBanner_top-banner__0DXyC"};